
import React from 'react';
import {RootWrapper} from './components/Wrapper'
import {createRoot} from 'react-dom/client'

/**
 * 
 * @param {React.Component} Componente - uno dei componenti React che devo esportare dal file lib/reactapp/index.js del plugin 
 * @param {*} props - props del componente
 * @param {Element} dest - elemento del dom in cui farò il rendering del componente
 * @param {import('@mui/material').Theme} theme
 * @returns 
 */
const render = (Componente, props, dest, theme = null, append = false, unwrapped = false) => {

    if(append){
        dest = dest.appendChild(document.createElement("div"));
    }

    const Container = unwrapped ? React.Fragment : RootWrapper;
    
    const root = createRoot(dest);

    return root.render(
        <Container theme={theme ?? {}}>
            <Componente {...props} />
        </Container>
    );
}


export default render;

